import { Button } from "@/src/components/buttons";
import { CompartmentCard } from "@/src/components/cards";
import { FetchableList } from "@/src/components/fetchableLists";
import apiFetch from "@/src/utils/apiFetch";
import { uid } from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";

export function CreditsList({
  patientId,
}: {
  patientId: string | null | undefined;
}) {
  const [reload, setReload] = useState(0);
  if (!patientId)
    return <div className="gray center p20">Aucun patient selectionné</div>;

  return (
    <CompartmentCard title="Crédits">
      <FetchableList
        queryKey={["CreditsList", patientId, reload]}
        queryFn={() =>
          apiFetch(
            "credits",
            "loadPatientCredits",
            { patientId, statuses: ["pending"] },
            ""
          )
        }
      >
        {(data) => {
          return (
            <div className="c1 gap10">
              {data?.map((credit, index) => {
                return (
                  <div key={uid()} className="card">
                    <div className="acenter c2 gap10">
                      <div>
                        <div className="bold">{credit.amount} DZD</div>
                        <div className="gray">
                          {moment(credit._date).format("LL HH:mm")}
                        </div>
                      </div>
                      <Button
                        onClick={async () => {
                          credit.status = "paid";
                          let result = await apiFetch("credits", "addOne", {
                            credit,
                          });
                          if (!result) return;
                          credit = result;
                          setReload((prev) => prev + 1);
                        }}
                      >
                        Encaisser crédit {credit.amount} DZD
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        }}
      </FetchableList>
    </CompartmentCard>
  );
}
